import { render, staticRenderFns } from "./PortfolioInfo.vue?vue&type=template&id=72988bd8"
import script from "./PortfolioInfo.vue?vue&type=script&lang=js"
export * from "./PortfolioInfo.vue?vue&type=script&lang=js"
import style0 from "./PortfolioInfo.vue?vue&type=style&index=0&id=72988bd8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProfileImg: require('/skade-pwa/components/ui/atom/ProfileImg.vue').default,ChangePercent: require('/skade-pwa/components/ui/atom/ChangePercent.vue').default,PortfolioRankTag: require('/skade-pwa/components/ui/atom/PortfolioRankTag.vue').default,PortfolioPrivacyTag: require('/skade-pwa/components/ui/atom/PortfolioPrivacyTag.vue').default})
